<div id="container">
    <div id="title">User Data Api</div>
    <img src="../../../assets/close_small.png" width="10px" height="10px" alt="" id="icon">
</div>